import { Reveal } from "../components/Reveal";
import { motion } from "framer-motion";
import { Gift, HandHeart, Envelope } from "@phosphor-icons/react";
import { scrollToId } from "../lib/scroll";
import { useSiteImages } from "../context/SiteImagesContext";

const PILLARS = [
  {
    Icon: Gift,
    title: "Envuelta a mano",
    text: "Cada regalo se prepara con papel de seda, cinta y un lazo hechos a mano.",
  },
  {
    Icon: Envelope,
    title: "Tarjeta dedicada",
    text: "Escribe hasta 300 palabras y las incluimos en una tarjeta impresa con mimo.",
  },
  {
    Icon: HandHeart,
    title: "Enviado directo",
    text: "Podemos enviarla directamente a la persona destinataria, sin factura visible.",
  },
];

export default function Regalo() {
  const { resolve } = useSiteImages();

  return (
    <section
      id="regalo"
      data-testid="regalo-section"
      className="py-24 md:py-32 bg-[#2D3732] text-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-6 relative">
          <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] bg-[#3d4841]">
            <img
              src={resolve("gallery:carpeta", `/api/images/gallery:carpeta`)}
              alt="VITAE envuelta para regalo"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D3732]/70 via-transparent to-transparent" />
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-md rounded-2xl px-6 py-5 flex items-center gap-4"
            >
              <div className="w-11 h-11 rounded-full bg-[#F6F1E7] flex items-center justify-center flex-shrink-0">
                <Gift size={20} weight="light" className="text-[#8A9A6F]" />
              </div>
              <div className="flex-1">
                <p className="font-display text-lg text-[#2D3732] leading-tight">
                  Envolver para regalo
                </p>
                <p className="text-xs text-[#6B705C]">
                  +3 € · Incluye tarjeta con dedicatoria
                </p>
              </div>
            </motion.div>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-6">
          <p className="overline mb-6 text-[#A3B18A]">
            <span className="text-[#D7C6A3]">07</span> &nbsp;/&nbsp; Regalo
          </p>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">
            Un regalo distinto
            <br />
            <span className="text-[#C6D0B2]">para los tuyos.</span>
          </h2>
          <p className="text-white/70 mt-6 max-w-lg font-light leading-relaxed">
            Regalar VITAE es acompañar. A tu madre, a una amiga en tratamiento, a esa
            persona que empieza un embarazo, a alguien que carga una enfermedad invisible.
            Un gesto sencillo que dice: <em>estoy contigo</em>.
          </p>

          <div className="grid sm:grid-cols-3 gap-4 mt-10">
            {PILLARS.map(({ Icon, title, text }) => (
              <div
                key={title}
                className="border border-white/10 rounded-2xl p-5 hover:border-[#A3B18A]/60 transition-colors duration-500"
              >
                <Icon size={24} weight="light" className="text-[#A3B18A]" />
                <p className="font-display text-lg mt-3 leading-tight">{title}</p>
                <p className="text-xs text-white/60 mt-1.5 font-light leading-relaxed">
                  {text}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="regalo-cta"
              onClick={() => scrollToId("colecciones")}
              className="bg-[#A3B18A] hover:bg-[#8A9A6F] text-white rounded-full pl-7 pr-6 py-4 text-sm tracking-wide transition-colors duration-300"
            >
              Elegir una para regalar
            </button>
            <p className="text-xs text-white/50">
              Activa la opción de regalo en la carpeta que elijas.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
